/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSize } from "../../../hooks/useSize";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../Component/Tooltip";
import { useEmpaque } from "../hooks/useEmpaque";
import { useNotificationNumbers } from "../../../hooks/useNotification.Numbers";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { useNotification } from "../hooks/useNotification";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export const PedidoTable = ({
  empaqueData,
  id_cultivo,
  setEmpaqueData,
  handleBicolorClick,
  handleNewEmpaqueClick,
  handleEditClick,
  reload,
  fecha,
  updateOnSave,
}) => {
  const { getPedidoEmpaqueNotificationNumbers } = useNotificationNumbers();
  const { createNotification } = useNotification();
  const { destroyPedido, saveEmpaque } = useEmpaque();
  const { getSize } = useSize();
  const [size, setSize] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [pedidoAtuomaticoOpen, setPedidoAutomaticoOpen] = useState({
    campo_id: null,
    diaria_id: null,
    variedad_id: null,
    variedad: null,
    calibre: null,
    calibre_total: null,
    visible: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const user = localStorage.getItem("@usuario");
  const json_user = JSON.parse(user);

  const deletePedido = (id) => {
    Swal.fire({
      icon: "warning",
      title: "¿Está seguro que desea eliminar el pedido?",
      text: "Los pedidos eliminados no se podran recuperar",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "green",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      backdrop: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          await destroyPedido(id);
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Pedido eliminado",
          timer: 1500,
        });
        reload();
      }
    });
  };

  const handleSetVariedadVisible = (campo_index, variedad_index) => {
    const empaque = [...empaqueData];
    const isVisible = empaque[campo_index].variedades[variedad_index].isVisible;
    empaque[campo_index].variedades[variedad_index].isVisible = !isVisible;
    setEmpaqueData(empaque);
  };

  const sendNotification = (id_campo, estatus, variedad) => {
    const campo_numbers = numbers.filter((item) => item.id_campo === id_campo);
    Swal.fire({
      icon: "info",
      title: "Se enviará una notificación",
      text: "¿Está seguro que desea enviar la notificación?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        let inicio = `Les informamos que ${json_user.nombre} ${json_user.apellido} ha terminado el pedido`;
        if (estatus === 2) {
          inicio = `${json_user.nombre} ${
            json_user.apellido
          } ha modificado el pedido ${
            variedad !== "" ? "de la variedad " + variedad : ""
          }`;
        }
        await campo_numbers.reduce(async (promise, current) => {
          await promise;
          var data = JSON.stringify({
            token: process.env.REACT_APP_NOTIFICATION_TOKEN,
            to: current.number,
            body: `✉️ Notificación automática:
  
    ${inicio} del día 📅 ${moment(fecha).format(
      "DD/MM/YYYY",
    )} y se encuentra disponible en la plataforma, favor de verificarlo ✅ https://comercial.divineflavororg.com/empaque/orden/?fecha=${fecha}`,
          });

          var config = {
            method: "post",
            url: `https://api.ultramsg.com/${process.env.REACT_APP_NOTIFICATION_INSTANCE}/messages/chat`,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          try {
            await axios(config);
          } catch (error) {
            Swal.showValidationMessage(
              `Error - Favor de comunicarlo con el equipo de desarrollo`,
            );
            return;
          }
        }, Promise.resolve());
      },
      allowOutsideClick: () => {
        return !Swal.isLoading();
      },
      backdrop: true,
    }).then(async (res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Notificación enviada",
          timer: 1500,
        });
        await createNotification({
          id_campo: id_campo,
          fecha: fecha,
          estatus: estatus === 0 || estatus === 2 ? 1 : estatus,
        });
        reload();
      }
    });
  };

  const closeModalPedido = () => {
    setPedidoAutomaticoOpen({
      campo_id: null,
      diaria_id: null,
      variedad_id: null,
      variedad: null,
      calibre: null,
      calibre_total: null,
      visible: false,
    });
  };

  const onPedidoAutomaticoClick = async (yeguer_id) => {
    setIsLoading(true);
    setError("");

    const total = Math.ceil(pedidoAtuomaticoOpen.calibre_total / 90);
    const data = {
      id_campo: pedidoAtuomaticoOpen.campo_id,
      id_diaria: pedidoAtuomaticoOpen.diaria_id,
      variedad: pedidoAtuomaticoOpen.variedad,
      variedad_bicolor: [],
      resto: true,
      calibre: pedidoAtuomaticoOpen.calibre,
      total: pedidoAtuomaticoOpen.calibre_total,
      id_tipo_etiqueta: 1,
      id_peso_envase: pedidoAtuomaticoOpen.variedad_id === 63 ? 3 : 4,
      id_tipo_caja: pedidoAtuomaticoOpen.variedad_id === 63 ? 3 : 10,
      id_etiqueta: pedidoAtuomaticoOpen.variedad_id === 63 ? 7 : 1,
      id_bultos_por_palet: 28,
      bultos_por_palet: 90,
      cantidad_palet: total,
      id_yeguere: yeguer_id,
      id_destino: 1,
      tipo_pedido: "Exacto",
      id_destino_inmediato: 4,
      id_tarima: 1,
      fumigar: false,
      prioridad: false,
      observaciones: "",
      fecha: fecha,
      limite: 0,
      bicolor: false,
      id_variedad: pedidoAtuomaticoOpen.variedad_id,
    };

    try {
      await saveEmpaque(data);
      closeModalPedido();
      Swal.fire({
        icon: "success",
        title: "Pedido guardado",
        timer: 1500,
        showConfirmButton: false,
      });
      updateOnSave();
    } catch (error) {
      setError(
        error?.response?.data?.detail ||
          "Ocurrió un error al guardar el pedido",
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getNumbers = async () => {
      const response = await getPedidoEmpaqueNotificationNumbers();
      setNumbers(response);
    };
    getNumbers();
  }, []);

  useEffect(() => {
    const getTamanio = async () => {
      const response = await getSize(id_cultivo);
      setSize(response);
    };
    if (id_cultivo !== "") {
      getTamanio();
    }
  }, [id_cultivo]);

  return (
    <>
      <div className="row">
        <div className="col-12 table-responsive">
          {empaqueData?.map((campo, campo_index) => (
            <table className="table" key={campo.id_campo}>
              <thead>
                <tr>
                  <th>
                    <button
                      className="btn btn-outline-primary"
                      style={{ marginRight: "10px" }}
                      onClick={() =>
                        handleBicolorClick(campo.id_campo, campo.campo)
                      }
                    >
                      <FontAwesomeIcon icon="far fa-clipboard" />
                    </button>
                    {campo.campo}
                  </th>
                  {size.map((item) => (
                    <th style={{ textAlign: "center" }} key={item.tamano}>
                      {item.tamano}
                    </th>
                  ))}
                  <th>
                    {campo.variedades.reduce(
                      (sum, variedad) => sum + variedad.proyeccion,
                      0,
                    )}
                  </th>
                  <th>
                    {campo.enviado.estatus !== 1 && (
                      <button
                        className="btn btn-outline-success"
                        onClick={() =>
                          sendNotification(
                            campo.id_campo,
                            campo.enviado.estatus,
                            campo.enviado.variedades,
                          )
                        }
                      >
                        <FontAwesomeIcon icon="fab fa-whatsapp" />
                      </button>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {campo.variedades.map((item, variedad_index) => (
                  <VariedadRow
                    variedad={item}
                    size={size}
                    key={item.id_variedad}
                    handleSetVisible={() =>
                      handleSetVariedadVisible(campo_index, variedad_index)
                    }
                    handleAddEmpaque={() =>
                      handleNewEmpaqueClick(campo.id_campo, item.id_variedad)
                    }
                    onEditClick={handleEditClick}
                    onDeleteClick={deletePedido}
                    colSpan={size.length + 3}
                    onPedidoAutomaticoClick={
                      (calibre, total) =>
                        setPedidoAutomaticoOpen({
                          ...pedidoAtuomaticoOpen,
                          campo_id: campo.id_campo,
                          variedad_id: item.id_variedad,
                          diaria_id: item.id_diaria,
                          variedad: item.variedad,
                          calibre: calibre,
                          calibre_total: total,
                          visible: true,
                        })
                      // onPedidoAutomaticoClick(
                      //   campo.id_campo,
                      //   item.id_diaria,
                      //   item.id_variedad,
                      //   item.variedad,
                      //   calibre,
                      //   total,
                      // )
                    }
                  />
                ))}
              </tbody>
            </table>
          ))}
        </div>
      </div>
      <Modal
        isOpen={pedidoAtuomaticoOpen.visible}
        toggle={closeModalPedido}
        size="md"
        centered
      >
        <ModalHeader toggle={!isLoading ? closeModalPedido : undefined}>
          Generar pedido de empaque
        </ModalHeader>

        <ModalBody>
          <div className="text-center mb-4">
            <div
              className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{
                width: "70px",
                height: "70px",
                fontSize: "32px",
              }}
            >
              📦
            </div>

            <h5 className="fw-bold">Pedido automático</h5>

            <p className="text-muted mb-0">Se creará un pedido convencional:</p>

            <div className="mt-3 p-3 bg-light rounded border">
              <div className="fw-semibold">
                {pedidoAtuomaticoOpen.variedad_id === 63
                  ? "16Lbs • 9 bag • DF"
                  : "18Lbs • 8 bag • DF CLEAR"}
              </div>

              <small className="text-muted">90 bultos por palet</small>
            </div>
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <div className="d-grid gap-2">
            <button
              className="btn btn-outline-success btn-lg text-start"
              disabled={isLoading}
              onClick={() => onPedidoAutomaticoClick(1)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="fw-bold">Liner</div>

                  <small className="text-muted">
                    Pedido con liner estándar
                  </small>
                </div>

                {isLoading && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                )}
              </div>
            </button>

            <button
              className="btn btn-outline-primary btn-lg text-start"
              disabled={isLoading}
              onClick={() => onPedidoAutomaticoClick(2)}
            >
              <div className="fw-bold">Liner / Pad de azufre</div>

              <small className="text-muted">Incluye protección adicional</small>
            </button>

            <button
              className="btn btn-outline-secondary btn-lg text-start"
              disabled={isLoading}
              onClick={() => onPedidoAutomaticoClick(8)}
            >
              <div className="fw-bold">No aplica</div>

              <small className="text-muted">Sin yeguere asignado</small>
            </button>
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            className="btn btn-light w-100 btn-cancel"
            disabled={isLoading}
            onClick={closeModalPedido}
          >
            {isLoading ? "Guardando..." : "Cancelar"}
          </button>
        </ModalFooter>
      </Modal>
      <style>
        {`.btn-cancel {
            transition: all 0.2s ease;
          }

          .btn-cancel:hover {
            background-color: #dc3545;
            border-color: #dc3545;
            color: white;
          }`}
      </style>
    </>
  );
};

const VariedadRow = ({
  variedad,
  size,
  handleSetVisible,
  handleAddEmpaque,
  onPedidoAutomaticoClick,
  onEditClick,
  onDeleteClick,
  colSpan,
}) => {
  return (
    <>
      <tr>
        <td>
          <button
            className="btn btn-primary btn-sm"
            style={{ borderRadius: "100px" }}
            onClick={handleSetVisible}
          >
            {variedad.isVisible ? (
              <FontAwesomeIcon icon="fas fa-minus" />
            ) : (
              <FontAwesomeIcon icon="fas fa-plus" />
            )}
          </button>{" "}
          {variedad.variedad}
        </td>
        {size.map((item) => {
          const total =
            variedad.tamanos.find((tamanio) => tamanio.tamanio === item.tamano)
              ?.total ?? 0;
          return (
            <td key={item.tamano} style={{ textAlign: "center" }}>
              {total}
              <br />
              <button
                className="btn btn-sm"
                onClick={() => onPedidoAutomaticoClick(item.tamano, total)}
                disabled={total === 0}
              >
                <FontAwesomeIcon icon="fa-solid fa-clipboard-list" />
              </button>
            </td>
          );
        })}
        <td>{variedad.proyeccion}</td>
        <td>
          <button className="btn btn-outline-dark" onClick={handleAddEmpaque}>
            <FontAwesomeIcon icon="fas fa-boxes" />
          </button>
        </td>
      </tr>
      {variedad.isVisible && (
        <tr>
          <td colSpan={colSpan}>
            <table className="table mb-0">
              <tbody>
                {variedad.empaque.map((empaque) => (
                  <tr key={empaque.id_pedido}>
                    <td>
                      {empaque.bicolor && (
                        <FontAwesomeIcon
                          icon="fas fa-project-diagram"
                          style={{ color: "#0d73a5" }}
                        />
                      )}
                    </td>
                    <td style={{ fontWeight: "bold" }}>{empaque.calibre}</td>
                    <td>{empaque.etiqueta}</td>
                    <td>Tipo: {empaque.tipo_etiqueta}</td>
                    <td>
                      Cantidad:{" "}
                      {empaque.resto
                        ? "Resto"
                        : empaque.bicolor
                          ? Math.round(empaque.resta / empaque.bultos_por_palet)
                          : empaque.cantidad_palet}{" "}
                      - {empaque.bultos_por_palet}
                      {empaque.bicolor && " / " + empaque.resta}
                    </td>
                    <td>
                      <Tooltip text={empaque.observaciones}>
                        Observaciones
                      </Tooltip>
                    </td>
                    <td>Fumigar: {!empaque.fumigar ? "No" : "Si"}</td>
                    <td>
                      {!empaque.bicolor && (
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() =>
                            onEditClick(empaque.id_pedido, variedad.id_variedad)
                          }
                        >
                          <FontAwesomeIcon icon="fas fa-pen" />
                        </button>
                      )}{" "}
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => onDeleteClick(empaque.id_pedido)}
                      >
                        <FontAwesomeIcon icon="fas fa-trash-alt" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </>
  );
};
